/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/youtubeFull': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 16.9',
    data: '<path pid="0" d="M23.5 2.6c-.3-1-1.1-1.9-2.1-2.1C19.5 0 12 0 12 0S4.5 0 2.6.5C1.6.8.8 1.6.5 2.6 0 4.5 0 8.5 0 8.5s0 3.9.5 5.8c.3 1 1.1 1.9 2.1 2.1 1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5c1-.3 1.8-1.1 2.1-2.1.5-1.9.5-5.8.5-5.8s0-4-.5-5.9zM9.5 12V4.9l6.3 3.6L9.5 12z"/>'
  }
})
